export function getCache(cache, functionName, key) {
    if (!cache[functionName]) {
        // создаем поля для хранения закешированных функций с таким именем
        cache[functionName] = {};
    }
    return cache[functionName][key];
}
export function setCache(cache, functionName, key, cachedObj) {
    cache[functionName][key] = cachedObj;
}
export function arraysEqual(arr1, arr2) {
    if (!arr1 || !arr2) {
        return false;
    }
    if (arr1.length != arr2.length) {
        return false;
    }
    for (var i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }
    return true;
}
